<template>
  <el-row
    :gutter="10"
    justify="space-between"
    class="mt-20 mb-30"
    style="width: auto"
  >
    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <card-total
        text="Nuevas"
        icon="mdi  mdi-folder-plus success-text"
        :count="myRequestNewCount"
        :total="myRequestNewCount"
        :loading.sync="loading"
      />
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <!-- el-icon-open -->
      <card-total
        text="En Progreso"
        icon="mdi mdi-satellite-uplink success-text"
        :count="myRequestInProgressCount"
        :total="myRequestInProgressCount"
        :loading.sync="loading"
      />
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <card-total
        text="Por Calificar"
        icon="mdi mdi-checkbox-multiple-marked-outline  success-text"
        :count="myRequestInClosedCount"
        :total="myRequestInClosedCount"
        :loading.sync="loading"
      />
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <card-total
        text="Completadas"
        icon="mdi  mdi-checkbox-marked-circle  success-text"
        :count="myRequestCompletedCount"
        :total="myRequestCompletedCount"
        :loading.sync="loading"
      />
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <card-total
        text="Todas"
        icon="mdi  mdi-format-list-bulleted  success-text"
        :count="myRequestAllCount"
        :total="myRequestAllCount"
        :loading.sync="loading"
      />
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
      <card-total
        text="Canceladas"
        icon="mdi mdi-close-circle  error-text"
        :count="myRequestCancellCount"
        :total="myRequestCancellCount"
        :loading.sync="loading"
      />
    </el-col>
  </el-row>
</template>

<script>
import CardTotal from "@/components/CardTotalOriginal.vue";

export default {
  name: "cardcountRequest",
  data: function () {
    return {
      loading: false
    };
  },
  props: {
    myRequestNewCount: {
      type: Number,
      default: 0
    },
    myRequestInProgressCount: {
      type: Number,
      default: 0
    },
    myRequestInClosedCount: {
      type: Number,
      default: 0
    },
    myRequestCancellCount: {
      type: Number,
      default: 0
    },
    myRequestCompletedCount: {
      type: Number,
      default: 0
    },
    myRequestAllCount: {
      type: Number,
      default: 0
    }
  },
  components: {
    CardTotal
  }
};
</script>
<style>
.main-section {
  width: 100%;
  text-align: center;
  padding: 0px 0px;
  margin-bottom: 1%;
}
.dashbord {
  padding-left: 8px;

  display: inline-block;
  background-color: white;
  color: #fff;
  margin-top: 10px;
  width: 250px;
}
.icon-section i {
  font-size: 30px;
  padding: 10px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-top: -25px;
  margin-bottom: 10px;
  background-color: #34495e;
}
.icon-section p {
  margin: 0px;
  font-size: 20px;
  padding-bottom: 10px;
}
.detail-section {
  background-color: #2f4254;
  padding: 5px 0px;
}
.dashbord .detail-section:hover {
  background-color: #5a5a5a;
  cursor: pointer;
}
.detail-section a {
  color: #fff;
  text-decoration: none;
}
.dashbord-white .icon-section,
.dashbord-white .icon-section i {
  background-color: #34495e;
}
.dashbord-white .detail-section {
  background-color: #34495e;
}
.dashbord-green .icon-section,
.dashbord-green .icon-section i {
  background-color: #16a085;
}
.dashbord-green .detail-section {
  background-color: #149077;
}
.dashbord-orange .icon-section,
.dashbord-orange .icon-section i {
  background-color: #f39c12;
}
.dashbord-orange .detail-section {
  background-color: #da8c10;
}
.dashbord-blue .icon-section,
.dashbord-blue .icon-section i {
  background-color: #2980b9;
}
.dashbord-blue .detail-section {
  background-color: #2573a6;
}
.dashbord-red .icon-section,
.dashbord-red .icon-section i {
  background-color: #e74c3c;
}
.dashbord-red .detail-section {
  background-color: #cf4436;
}
.dashbord-skyblue .icon-section,
.dashbord-skyblue .icon-section i {
  background-color: #b679cf;
}
.dashbord-skyblue .detail-section {
  background-color: #b061d0;
}
</style>
